import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/img/topPic.png'
import _imports_1 from '../assets/img/userPic.png'
import _imports_2 from '../assets/img/Vector347.png'
import _imports_3 from '../assets/img/butPic.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "topPic",
  src: _imports_0
}, null, -1)
const _hoisted_2 = { class: "userSetting" }
const _hoisted_3 = { class: "userName" }
const _hoisted_4 = { class: "rich-conent" }
const _hoisted_5 = {
  class: "setting",
  style: {"margin-left":"36px","font-size":"18px","color":"#fff","position":"relative","top":"45px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {"width":"16px"}
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "安优查可视化平台", -1)
const _hoisted_8 = { style: {} }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "butPic",
  src: _imports_3
}, null, -1)

import "@/font/css/font.css";
import { ref, unref, onMounted, onActivated, watch } from "vue";
import { useRouter, useRoute } from 'vue-router'
import javaapi from "@/service/javaapi";
import { ElMessage } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'GeneralLayout',
  setup(__props) {

onMounted(() => {
  //获取机构名称
  organization_name.value = localStorage.getItem("organization_name")
  if (route.path == '/user/institution/gis') {
    activeName.value = "GISPage"
  }
  if (route.path == '/user/program') {
    activeName.value = "Program"
  }
  //console.log("页面名称：" + activeName.value)
  if (localStorage.getItem('is_positive')) {
    radio.value = <string>localStorage.getItem('is_positive')
  } else {
    localStorage.setItem('is_positive', radio.value)
  }


})
const router = useRouter()
const route = useRoute()

watch(
  () => route.path,
  (newVal, oldVal) => {
    // console.log(newVal,oldVal,"=======")
      organization_name.value = localStorage.getItem("organization_name")
      if (route.path == '/user/institution/gis') {
        activeName.value = "GISPage"
      }
      if (route.path == '/user/program') {
        activeName.value = "Program"
      }
      //console.log("页面名称：" + activeName.value)
      if (localStorage.getItem('is_positive')) {
        radio.value = <string>localStorage.getItem('is_positive')
      } else {
        localStorage.setItem('is_positive', radio.value)
      }
    }
)
const handleChange = () => {
  localStorage.setItem('is_positive', radio.value)
}

const buttonRef = ref()

const activeName = ref("GISPage")
const popoverRef = ref()
const radio = ref('1')
const organization_name = ref(
  //获取机构名称
  localStorage.getItem("organization_name")
)

const onClickOutside = () => {
  unref(popoverRef).popperRef?.delayHide?.()
}

const logout = async () => {

  //TODO:登出
  let query = {
    jsonText: {},
    user_id: localStorage.getItem("user_id"),
    token: localStorage.getItem("token"),
  }
  let result = await javaapi.postQuery(query, "/users/logout")
  if (result.status == '1') {
    ElMessage.success("登出成功")
    javaapi.removeLoginInfo()
    router.push({
      name: 'login'
    });
  }
}

const jumpTo = async () => {
  //console.log("页面名称：" + activeName.value)
  let page = '';
  if (activeName.value == 'GISPage') {
    page = 'GISPage';
  }
  if (activeName.value == 'Program') {
    page = 'Program';
  }

  router.push({
    name: page
  });

}


return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ion_app = _resolveComponent("ion-app")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_unref(route).path != '/login')
    ? (_openBlock(), _createBlock(_component_ion_app, { key: 0 }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("img", {
              class: "userPic",
              ref_key: "buttonRef",
              ref: buttonRef,
              src: _imports_1
            }, null, 512), [
              [_directive_click_outside, onClickOutside]
            ]),
            _createElementVNode("div", _hoisted_3, _toDisplayString(organization_name.value), 1)
          ]),
          _createVNode(_component_el_popover, {
            class: "popover",
            ref_key: "popoverRef",
            ref: popoverRef,
            "virtual-ref": buttonRef.value,
            trigger: "click",
            "show-arrow": false,
            "virtual-triggering": ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createTextVNode(" 设置 "),
                  _createVNode(_component_el_radio_group, {
                    modelValue: radio.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((radio).value = $event)),
                    onChange: handleChange,
                    style: {"display":"flex","flex-direction":"column","font-size":"18px","color":"#fff"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, {
                        label: '1',
                        style: {"color":"#fff","font-family":"PingFang SC-常规体, PingFang SC"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("得分项")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, {
                        label: '0',
                        style: {"color":"#fff","font-family":"PingFang SC-常规体, PingFang SC"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("问题项")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, {
                        label: '2',
                        style: {"margin-left":"13px","color":"#fff","font-family":"PingFang SC-常规体, PingFang SC"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("全部内容")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", {
                  onClick: logout,
                  style: {"margin-left":"52px","font-size":"18px","position":"relative","top":"45px","color":"#fff","cursor":"pointer"}
                }, "退出")
              ])
            ]),
            _: 1
          }, 8, ["virtual-ref"]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_tabs, {
              modelValue: activeName.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeName).value = $event)),
              class: "generalTabs",
              onTabChange: jumpTo
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  class: "el-tab-pane",
                  label: "机构",
                  name: "GISPage"
                }),
                _createVNode(_component_el_tab_pane, {
                  class: "el-tab-pane",
                  label: "项目",
                  name: "Program"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createVNode(_component_router_view),
          _hoisted_9
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})